/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO simple para listar competiciones en la cabecera del equipo. 
 */
export interface CompetitionSimpleDTO { 
    id: number;
    name: string;
}

